import icons from 'assets/icons';
import { ROOT_ROUTE } from 'components/constants';
import React from 'react';
import { LinkWithQuery } from '../LinkWithQuery';
import styles from './styles.module.scss';

function MobileLogo() {
  return (
    <h1 className={`${styles.mobileLogo} absolute top-0 z-50`}>
      <LinkWithQuery to={ROOT_ROUTE}>
        <img src={icons.storycardsLogoNoText} title="Storycards" alt="Storycards" />
      </LinkWithQuery>
    </h1>
  );
}

export default MobileLogo;
